var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38584 10.5573C0.604787 11.3384 0.604787 12.6047 1.38584 13.3858L10.5574 22.5573C11.3385 23.3384 12.6048 23.3384 13.3858 22.5573L22.5574 13.3858C23.3385 12.6047 23.3385 11.3384 22.5574 10.5573L13.3858 1.38577C12.6048 0.604725 11.3385 0.604726 10.5574 1.38577L1.38584 10.5573ZM10.6273 5.85512C10.6273 5.10526 11.2351 4.49738 11.985 4.49738C12.7349 4.49738 13.3427 5.10526 13.3427 5.85511V12.1912C13.3427 12.9411 12.7349 13.549 11.985 13.549C11.2351 13.549 10.6273 12.9411 10.6273 12.1912V5.85512ZM13.3427 16.717C13.3427 17.4669 12.7349 18.0748 11.985 18.0748C11.2351 18.0748 10.6273 17.4669 10.6273 16.717C10.6273 15.9672 11.2351 15.3593 11.985 15.3593C12.7349 15.3593 13.3427 15.9672 13.3427 16.717Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b08bcc49.svg";
export { ForwardRef as ReactComponent };